import React from 'react'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import Block from '../components/Block';
import Heading from '../components/Heading';
import Description from '../components/Description';
import Emphasis from '../components/Emphasis';
import Grid from '@mui/material/Grid/Grid';

import { Parallax } from 'react-scroll-parallax';
import touch from '../assets/touch.png';
import { ReactComponent as TouchShapesPink } from '../assets/touch_shapes_pink.svg';
import { ReactComponent as TouchShapesBlue } from '../assets/touch_shapes_blue.svg';
import { ReactComponent as TouchShapesGreen } from '../assets/touch_shapes_green.svg';

interface IState {
}

interface IProps extends WithTranslation {
}

class About extends React.Component<IProps, IState, WithTranslation> {

	constructor(props: IProps){		
		super(props);				
		this.state = {};
	}

	render() {	
		const t = this.props.t;
        const ns = 'main';

		return <Block color='background.default'>

            <Grid container spacing={6} className='full-height'>
                <Grid item md={6} className='illustration'>
                    <Parallax className='parallax' speed={-8}>
                        <TouchShapesPink />
                    </Parallax>
                    <Parallax className='parallax' speed={7}>
                        <TouchShapesBlue />
                    </Parallax>
                    <Parallax className='parallax' speed={-6}>
                        <TouchShapesGreen />
                    </Parallax>
                    <Parallax className='parallax' speed={1}>
                        <img src={touch} alt='' />
                    </Parallax>
                </Grid>

                <Grid item md={6}>
                    <Heading>
                        {t('what-lotus-is', {ns})}
                    </Heading>

                    <Description>
                        <Trans i18nKey='about-lotus' ns={ns} components={[ <Emphasis /> ]} />
                    </Description>
                </Grid>
            </Grid>
        </Block>;
	}
}

export default withTranslation()(About);